module.exports = __webpack_public_path__ + "img/ch1.5d927c64.jpeg";